import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2'

import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { WalletDisconnectButton, WalletModalProvider, WalletMultiButton} from "@solana/wallet-adapter-react-ui";
import { Payload, SIWS } from "@web3auth/sign-in-with-solana";
import {thousands_separators, ConstructOptimalTransaction} from "../../helpers/utilities";
import { Connection, PublicKey, Transaction, LAMPORTS_PER_SOL, SystemProgram } from '@solana/web3.js'

import {apiSolPrice,apiGetCard} from "./../../helpers/apiData";

import * as anchor from "@coral-xyz/anchor";
import { Program, web3 } from "@coral-xyz/anchor";
import NodeWallet from "@coral-xyz/anchor/dist/cjs/nodewallet";
import idl from "../../program/idl.json";

import {userSOLBalance} from './../../helpers/userSolBalance';
import { Buffer } from "buffer";
import {
	SOLANA_CONNECTION,
	PROGRAM_ID,
	getKeypairFromBs58,
	feeAddress,
	relayAddress,
	CARDDATA,
	BASE_URL
} from "../../helpers/base_config";

import { toast } from "react-toastify";
// import env from "react-dotenv";
const defaultCardResult = ['1','1','1','1','1','1','1','1'];
let isDrawing = false;
let loadOnce = false;
let firstLoad = false;
let hasBought = false;
let hasRevealed = false;
let scratchAreas = [];
let multiplier = 0;
let level = 0;
let cardId = 0;
let cardResult = defaultCardResult;

function Board() {
	
	const wallet = useWallet();
	const {connection} = useConnection();
	const [solBalance, setSolBalance] = useState(0);
	const [refTicketSold, setRefTicketSold] = useState(0);
	const [refCommissionClaimed, setRefCommissionClaimed] = useState(0);
	const [refCommission, setRefCommission] = useState(0);
	const [address, setAddress] = useState('');
	const [cardStatus, setCardStatus] = useState(1);
	const [isWinning, setIsWinning] = useState(false);
	const [currentCardIndex, setCurrentCardIndex] = useState(0);
	
	const defaultCardActiveClass = ['','','','','','','','','',''];
	const [cardActiveClass, setCardActiveClass] = useState(defaultCardActiveClass);
	
	const [cardsData, setCardsData] = useState(CARDDATA);
	const [winGifs, setWinGifs] = useState({
		tier1: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2dtYWhjOWU2MjhhemduOWZoNWt1YTh4ZTllZzk0b3o1NTN1dHJpZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/HC7U9FpSfJ14AKtzYG/giphy.gif",
		tier2: "https://media.giphy.com/media/26FLgGTPUDH6UGAbm/giphy.gif",
		tier3: "https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif",
		tier4: "https://media.giphy.com/media/3o6Zt6KHxJTbXCnSvu/giphy.gif",
		tier5: "https://media.giphy.com/media/l0HlvtIPzPdt2usKs/giphy.gif",
		mega: "https://media.giphy.com/media/3ohhwxqQJzrSXnvWoM/giphy.gif",
		loss: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExeWo3YmlmcmZ5NjJxczlzc3NjYTJ5NXI3YTZkamRqbTlwNmZjMmVpMyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/KK3vJ5t9vwDw1SkGhZ/giphy.gif"
	  });
	  
	const [solPrice, setSolPrice] = useState(0);
	const [dataTransaction, setDataTransaction] = useState([]);
	
	async function getSolPrice(){
		let dataSolPrice = await apiSolPrice();
		setSolPrice(dataSolPrice.data.USD);
	}
	
	if(solPrice == 0){
		getSolPrice();
	}
	
	let walletAddress = "";
	let program =  "";
	
	if (wallet.connected && wallet.publicKey) {
		walletAddress = wallet.publicKey.toString();
		program =  new Program(idl, PROGRAM_ID, new anchor.AnchorProvider(SOLANA_CONNECTION, wallet.publicKey, anchor.AnchorProvider.defaultOptions()));
		
		if(walletAddress != address){
			firstLoad = false;
			getSolBalance();
			getCardGameData();
			setAddress(walletAddress);
		}
	} else {
		if(!firstLoad){
			showCard(0);
			firstLoad = true;
		}
	}
	
	async function showCard(index) {
		window.playClickSound();
		if (hasBought && !hasRevealed) {
			toast.error("You must reveal the active card before switching.");
			return;
		} else {
			setCurrentCardIndex(index);
			let CardActiveClass = defaultCardActiveClass;
			CardActiveClass[index] = 'active';
			setCardActiveClass(CardActiveClass);
			await renderScratchCard(0,false);
		}
	}
	
	async function renderScratchCard(card_id,bought) {
		let dataCard = await apiGetCard(card_id);
		
		if(typeof dataCard.data === 'object'){
			let data = dataCard.data;
			
			if(data.status === 'success'){
				let card = data.data;
				let id = card.card_id;
				let card_result = card.card_result;
				let card_result_data = card_result.split(',');
				
				if(id > 0){
					cardResult = card_result_data;
				}
				
				setTimeout(() => {
					initScratchEffect(bought);
					Swal.closeModal();
				}, "500");
			} else {
				setTimeout(() => {
					renderScratchCard(card_id,bought);
				}, "1000");
			}
		} else {
			setTimeout(() => {
				renderScratchCard(card_id,bought);
			}, "1000");
		}
				
		
		
		// const values = await getRandomizedValues(multiplier, cardIndex);

		// setCardResult(values);
		
	}
	
	async function initClear() {
		document.querySelectorAll('.card-section.active .scratch-box canvas').forEach(canvas => {
			const ctx = canvas.getContext('2d');
			ctx.globalCompositeOperation = 'destination-out';
			ctx.clearRect(0, 0, canvas.width, canvas.height);
		});
	}
	
	async function initScratchEffectLoad() {
		// console.log('load once');
		const soundScratch = document.getElementById('soundScratch');
		
		window.addEventListener('pointerdown', listenerFunction);

		window.addEventListener('pointerup', () => {
			isDrawing = false;
			if (soundScratch) soundScratch.pause();
		});

		window.addEventListener('pointermove', (e) => {
			if (isDrawing) {
				scratchAtPosition(e.clientX, e.clientY);
			}
		});
		
		window.addEventListener('resize', () => {
			setTimeout(() => {
				scratchAreas.forEach(area => {
					const rect = area.canvas.getBoundingClientRect();
					area.left = rect.left;
					area.top = rect.top;
					area.right = rect.right;
					area.bottom = rect.bottom;
				});
			}, 100);
		});
	}
	
	function getHasBought(){
		return hasBought;
	}
	
	async function initScratchEffect(bought) {
		
		const activeCard = document.querySelector('.card-section.active');
		activeCard.querySelectorAll('.value-text').forEach(el => el.classList.remove('win-match', 'win'));
		
		const boxes = document.querySelectorAll('.scratch-box');
		const img = new Image();
		img.src = '/all/scratchcircle.png';
		const soundScratch = document.getElementById('soundScratch');

		const canvasMap = new Map();
		scratchAreas = [];
		
		img.onload = () => {
			boxes.forEach(box => {
				const canvas = box.querySelector('canvas');
				if (!canvas) return;
				const ctx = canvas.getContext('2d');
				ctx.globalCompositeOperation = 'source-over';
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
				canvasMap.set(canvas, ctx);
				const rect = canvas.getBoundingClientRect();
				scratchAreas.push({
					canvas,
					ctx,
					left: rect.left,
					top: rect.top,
					right: rect.right,
					bottom: rect.bottom
				});
			});
		};
		
	}
	
	function listenerFunction(e) {
		const soundScratch = document.getElementById('soundScratch');
		if(getHasBought()) {
			
			isDrawing = true;
			if (soundScratch && soundScratch.paused) {
				soundScratch.currentTime = 0;
				soundScratch.play().catch(() => {});
			}
			scratchAtPosition(e.clientX, e.clientY);
		}
	}
	
	function scratchAtPosition(clientX, clientY) {
		scratchAreas.forEach(area => {
			const rect = area.canvas.getBoundingClientRect();
			const x = clientX - rect.left;
			const y = clientY - rect.top;

			if (x >= 0 && x <= area.canvas.width && y >= 0 && y <= area.canvas.height) {
				area.ctx.globalCompositeOperation = 'destination-out';
				area.ctx.beginPath();
				area.ctx.arc(x, y, 18, 0, Math.PI * 2);
				area.ctx.fill();
			}
		});
	}
	
	async function showLoading(title, text){
		Swal.fire({
			title: title,
			text: text,
			backdrop: true,
			allowOutsideClick : false,
			didOpen: () => {
				Swal.showLoading();
			  }
		});
	}
	
	async function buyCard(index) {
		
		if(wallet.connected && wallet.publicKey){
			window.playClickSound();
			if (hasBought && !hasRevealed) {
				toast.error("You must reveal the active card before buy new card.");
				return;
			} else {
				showLoading('Buy Card', 'Action Needed on your wallet');
				
				let sponsor = localStorage.getItem('sponsor');		
				if(sponsor !== null){
					try {
						sponsor = new PublicKey(sponsor);
					} catch (e) {	
						sponsor = new PublicKey(relayAddress);
					}
				} else {
					sponsor = new PublicKey(relayAddress);
				}
				
				
				const programId = new PublicKey(program.programId);
				const seedsCardNonceAccount = [Buffer.from('cardNonce')];
				const seedsPoolVaultAccount = [Buffer.from('poolVault')];
				const seedsCardDataAccount = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
				const referralCardDataAccount = [Buffer.from('referral'), sponsor.toBuffer()]; // Example seeds
				const [cardNonceAccount] = await PublicKey.findProgramAddress(seedsCardNonceAccount, programId);
				const [poolVaultAccount] = await PublicKey.findProgramAddress(seedsPoolVaultAccount, programId);
				const [cardDataAccount] = await PublicKey.findProgramAddress(seedsCardDataAccount, programId);
				const [referralDataAccount] = await PublicKey.findProgramAddress(referralCardDataAccount, programId);
				
				
				
				
				try {
					const transaction = new Transaction();
					const instruction = await program.methods.buyTicket(
						(index)
					).accounts({
						poolVault: poolVaultAccount,
						cardNonce: cardNonceAccount,
						cardDataAccount:cardDataAccount,
						referralDataAccount:referralDataAccount,
						poolfee: new PublicKey(feeAddress),
						referral: sponsor,
						relay: new PublicKey(relayAddress),
						player: wallet.publicKey,
						systemProgram: SystemProgram.programId,
					}).instruction();
					
					transaction.add(instruction);

					const signature = await wallet.sendTransaction(transaction, SOLANA_CONNECTION);
					showLoading('Draw Card', 'Please Wait...');
					await buyCardConfirmation();
				} catch (error) {
					toast.error(error);
					Swal.closeModal();
				}
			}
		} else {
			toast.error('Please Connect your wallet');
		}
	}
	
	async function buyCardConfirmation(){
		const seeds = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [cardDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let gameDataAccount = await program.account.cardDataAccount.fetch(
				cardDataAccount
			);
			cardResult = defaultCardResult;
			
			// console.log(gameDataAccount);
			let CardId = gameDataAccount.cardId;
			let CardStatus = gameDataAccount.cardStatus;
			let CardLevel = gameDataAccount.cardLevel;
			let Multiplier = gameDataAccount.cardMultiplier;
			let CardResult = gameDataAccount.cardResult;
			CardResult = CardResult.split(",");
			cardResult = CardResult;
			
			// console.log(CardId);
			// console.log(cardId);
			// console.log(CardStatus);
			
			if(CardId > cardId && CardStatus == 3){
				hasBought = true;
				hasRevealed = false;
				setCardStatus(CardStatus);
				multiplier = Multiplier;
				level = CardLevel;
				cardId = CardId;
				
				setTimeout(() => {
					initScratchEffect(true);
					Swal.closeModal();
				}, "500");
				
				// await renderScratchCard(CardId,true);
			} else {
				setTimeout(async () => {
					buyCardConfirmation();
				}, "500");
			}
		} catch (e) {
			setTimeout(async () => {
				buyCardConfirmation();
			}, "500");
		}
	}	
	
	async function getRandomizedValues(multiplier, cardIndex) {
		let result = [0, 0 ,0, 0, 0, 0, 0, 0];
		
		let dataReward = cardsData[cardIndex].reward;
		const reward = cardsData[cardIndex].price * multiplier;
		let index = dataReward.indexOf(reward);
		if (index !== -1) {
			dataReward.splice(index, 1);
		}
		
		let i = 0;
		for (const res of result) {
			let randomNumber = await getRandomReward(dataReward, result);
			result[i] = randomNumber
			i++;
		}
		
		let rewardPosition = [];
		let rewardPosition_1 = await getRandomPosition(rewardPosition);
		rewardPosition.push(rewardPosition_1);		
		let rewardPosition_2 = await getRandomPosition(rewardPosition);
		rewardPosition.push(rewardPosition_2);		
		let rewardPosition_3 = await getRandomPosition(rewardPosition);
		rewardPosition.push(rewardPosition_3);		
		
		result[rewardPosition_1] = cardsData[cardIndex].price * multiplier;
		result[rewardPosition_2] = cardsData[cardIndex].price * multiplier;
		result[rewardPosition_3] = cardsData[cardIndex].price * multiplier;
		
		
		// if (playCount > 0 && playCount % 5 === 0) {
		// const winPrize = prizes[Math.floor(Math.random() * prizes.length)];
		// result.push(winPrize, winPrize, winPrize);
		// while (result.length < 8) {
		// let randPrize;
		// do {
		// randPrize = prizes[Math.floor(Math.random() * prizes.length)];
		// } while (randPrize === winPrize);
		// result.push(randPrize);
		// }
		// return result.sort(() => 0.5 - Math.random());
		// }

		

		return result;
	}

	async function getRandomReward(arr, arr2) {
		let random = arr[getRandomInt(0,(arr.length - 1))];
		let index = arr2.indexOf(random);
		if (index === -1) {
			return random;
		} else {
			let index2 = arr2.indexOf(random, index);
			if (index2 === -1) {
				return random;
			} else {
				return getRandomReward(arr, arr2);
			}
		}
	}
	
	async function getRandomPosition(arr) {
		let random = getRandomInt(0, 7);
		let index = arr.indexOf(random);
		if (index === -1) {
			return random;
		} else {
			getRandomPosition(arr);
		}
	}
	
	function getRandomInt(min, max) {
		min = Math.ceil(min); // Ensures min is an integer
		max = Math.floor(max); // Ensures max is an integer
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	async function claimReferralCommission() {
		if(wallet.connected && wallet.publicKey){
			showLoading('Claim Referral Commission', 'Action Needed on your wallet');
		
			const programId = new PublicKey(program.programId);
			const seedsPoolVaultAccount = [Buffer.from('poolVault')];
			const seedsReferralDataAccount = [Buffer.from('referral'), wallet.publicKey.toBuffer()]; // Example seeds
			const [poolVaultAccount] = await PublicKey.findProgramAddress(seedsPoolVaultAccount, programId);
			const [referralDataAccount] = await PublicKey.findProgramAddress(seedsReferralDataAccount, programId);

			try {
				const transaction = new Transaction();
				const instruction = await program.methods.claimReferralCommission()
				.accounts({
					poolVault: poolVaultAccount,
					referralDataAccount:referralDataAccount,
					referral: wallet.publicKey,
					systemProgram: SystemProgram.programId,
				}).instruction();
				
				transaction.add(instruction);
				
				const signature = await wallet.sendTransaction(transaction, SOLANA_CONNECTION);
				
				await claimReferralCommissionConfirmation(signature);
			} catch (error) {
				toast.error(error);
				Swal.closeModal();
			}
		} else {
			toast.error('Please Connect your wallet');
		}
	}
	
	async function claimReferralCommissionConfirmation(signature){
		const seeds = [Buffer.from('referral'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [referralDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let commissionDataAccount = await program.account.referralDataAccount.fetch(
				referralDataAccount
			);
			
			let RefCommissionClaimed = commissionDataAccount.refCommissionClaimed;
			let RefCommission = commissionDataAccount.refCommission;
					
			if(RefCommission - RefCommissionClaimed == 0){
				Swal.fire({
				  icon: "success",
				  title: "Congratulations",
				  text: "Commission has been send" ,
				  footer: '<a href="https://solscan.io/tx/'+signature+'" target="_blank">View on Solscan</a>'
				});
				
				getSolBalance();
			} else {
				setTimeout(async () => {
					claimReferralCommissionConfirmation(signature);
				}, "500");
			}
		} catch (e) {
			setTimeout(async () => {
				claimReferralCommissionConfirmation(signature);
			}, "500");
		}
	}	
	
	async function claimCard() {
		if(wallet.connected && wallet.publicKey){
			showLoading('Claim Reward', 'Action Needed on your wallet');
		
			const programId = new PublicKey(program.programId);
			const seedsPoolVaultAccount = [Buffer.from('poolVault')];
			const seedsCardDataAccount = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
			const [poolVaultAccount] = await PublicKey.findProgramAddress(seedsPoolVaultAccount, programId);
			const [cardDataAccount] = await PublicKey.findProgramAddress(seedsCardDataAccount, programId);
			
			
			try {
				const transaction = new Transaction();
				const instruction = await program.methods.revealCard()
				.accounts({
					poolVault: poolVaultAccount,
					cardDataAccount:cardDataAccount,
					player: wallet.publicKey,
					systemProgram: SystemProgram.programId,
				}).instruction();
				
				transaction.add(instruction);
				
				
				
				const signature = await wallet.sendTransaction(transaction, SOLANA_CONNECTION);
				
				await claimCardConfirmation(signature);
			} catch (error) {
				toast.error(error);
				Swal.closeModal();
			}
		} else {
			toast.error('Please Connect your wallet');
		}
	}
	
	async function claimCardConfirmation(signature){
		const seeds = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [cardDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let gameDataAccount = await program.account.cardDataAccount.fetch(
				cardDataAccount
			);
			
			// console.log(gameDataAccount);
			let CardId = gameDataAccount.cardId;
			let CardStatus = gameDataAccount.cardStatus;
			let CardLevel = gameDataAccount.cardLevel;
			let Multiplier = gameDataAccount.cardMultiplier;
			
			cardResult = defaultCardResult;
			
			if(CardStatus == 1){
				hasBought = false;
				hasRevealed = false;
			
				Swal.fire({
				  icon: "success",
				  title: "Congratulations",
				  text: "You Got $" + thousands_separators(cardsData[level].price * multiplier,2) ,
				  footer: '<a href="https://solscan.io/tx/'+signature+'" target="_blank">View on Solscan</a>'
				});
			} else {
				setTimeout(async () => {
					claimCardConfirmation(signature);
				}, "500");
			}
		} catch (e) {
			setTimeout(async () => {
				claimCardConfirmation(signature);
			}, "500");
		}
	}	
	
	async function revealCard() {
		window.playRevealSound();
		
		const seeds = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [cardDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let gameDataAccount = await program.account.cardDataAccount.fetch(
				cardDataAccount
			);
			
			let CardId = gameDataAccount.cardId;
			let CardStatus = gameDataAccount.cardStatus;
			let CardLevel = gameDataAccount.cardLevel;
			let Multiplier = gameDataAccount.cardMultiplier;
			
			document.querySelectorAll('.card-section.active .scratch-box canvas').forEach(canvas => {
				const ctx = canvas.getContext('2d');
				ctx.globalCompositeOperation = 'destination-out';
				ctx.clearRect(0, 0, canvas.width, canvas.height);
			});
			
			const activeCard = document.querySelector('.card-section.active');
			const texts = Array.from(activeCard.querySelectorAll('.value-text')).map(el => el.textContent.trim());

			const counts = {};
			texts.forEach(val => counts[val] = (counts[val] || 0) + 1);

			const match = Object.entries(counts).find(([val, count]) => count === 3);
			let winAmount = 0;
			
			if (match) {
				const raw = match[0]; // e.g. "$1K", "$100"
				
				// Reset effect classes
				activeCard.querySelectorAll('.value-text').forEach(el => el.classList.remove('win-match', 'win'));

				// Add highlight with animation only if exactly 3 match
				setTimeout(() => {
					const matchingEls = Array.from(activeCard.querySelectorAll('.value-text')).filter(el => el.textContent.trim() === raw);
					if (matchingEls.length === 3) {
						matchingEls.forEach(el => el.classList.add('win-match', 'win'));
							showWinPopup(cardsData[currentCardIndex].price * Multiplier);
							launchConfetti();
							window.playWinSound();
						}
				}, 100);
			} else {
				
				setTimeout(() => {
					showWinPopup(cardsData[currentCardIndex].price * Multiplier);
					window.playLoseSound();
				}, 100);
			}
			
			if(Multiplier == 0){
				hasRevealed = false;
				hasBought = false;
			} else {
				hasRevealed = true;
			}
		} catch (e) {
			// console.log(`error getting balance: `, e);
		}
	}
	
	function getWinTier(amount, cardPrice) {
		const multiplier = amount / cardPrice;
		if (multiplier >= 100) return 'mega';
		if (multiplier >= 50) return 'tier5';
		if (multiplier >= 25) return 'tier4';
		if (multiplier >= 15) return 'tier3';
		if (multiplier >= 10) return 'tier2';
		if (multiplier >= 1) return 'tier1';
		return 'loss';
	}
	
	function showWinPopup(amount) {
		const activeCard = document.querySelector('.card-section.active');
		const overlay = activeCard.querySelector('.win-overlay');
		overlay.style.display = 'block';
		overlay.innerHTML = '';

		setTimeout(() => {
			const popup = document.createElement('div');
			const formattedAmount = `${amount.toLocaleString()}`;
			const cardPrice = cardsData[currentCardIndex].price;
			const tier = getWinTier(amount, cardPrice);
			const gifUrl = winGifs[tier];

			if (tier === 'mega') {
				popup.className = 'win-popup mega-jackpot-popup';
				popup.innerHTML = `
				<div class="win-popup-title mega-jackpot-title">🎊 MEGA JACKPOT! 🎊</div>
				<div class="win-popup-amount mega-jackpot-amount">You Win ${formattedAmount}!</div>
				<img src="${gifUrl}" alt="mega win" class="mega-win-gif">
				<div class="win-popup-footer mega-jackpot-footer">💎 LEGENDARY WIN! 💎</div>
				`;
			} else {
				popup.className = 'win-popup';
				const tierMessages = {
					tier1: "🎉 Nice Win!",
					tier2: "🔥 Great Win!",
					tier3: "⭐ Amazing Win!",
					tier4: "💫 Epic Win!",
					tier5: "🚀 Incredible Win!",
					loss: "You're out of luck"
				};
				
				if(tier == 'loss'){
					popup.innerHTML = `
				<div class="win-popup-title">${tierMessages[tier]}</div>
				<div class="win-popup-amount">You Lose!</div>
				<img src="${gifUrl}" alt="win celebration" class="win-gif">
				<div class="win-popup-footer">May luck be with you on the next card</div>
				`;
				} else {
					popup.innerHTML = `
					<div class="win-popup-title">${tierMessages[tier]}</div>
					<div class="win-popup-amount">You Win ${formattedAmount}!</div>
					<img src="${gifUrl}" alt="win celebration" class="win-gif">
					<div class="win-popup-footer">🎊 Congratulations! 🎊</div>
					`;
				}
				
			}

			overlay.appendChild(popup);

			const animationDuration = tier === 'mega' ? 12000 : 8000;
			setTimeout(() => {
				overlay.innerHTML = '';
				overlay.style.display = 'none';
				setIsWinning(false);
				
			}, animationDuration);
		}, 1000);
	}

	function launchConfetti() {
		if (typeof window.confetti === 'function') {
			window.confetti({
				particleCount: 100,
				spread: 70,
				origin: {
					y: 0.6
				}
			});
		}
	}
	
	async function getSolBalance() {
		let balance = await userSOLBalance(wallet.publicKey, SOLANA_CONNECTION);
		setSolBalance(balance);
		
		const seeds = [Buffer.from('referral'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [referralDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let commissionDataAccount = await program.account.referralDataAccount.fetch(
				referralDataAccount
			);
			
			setRefTicketSold(commissionDataAccount.refTicketSold / 1);
			setRefCommissionClaimed(commissionDataAccount.refCommissionClaimed / LAMPORTS_PER_SOL);
			setRefCommission(commissionDataAccount.refCommission / LAMPORTS_PER_SOL);			
			
		} catch (e) {
			// console.log(`error getting balance: `, e);
		}
	}
		
	async function getCardGameData() {
		const seeds = [Buffer.from('ticket'), wallet.publicKey.toBuffer()]; // Example seeds
		const programId = new PublicKey(program.programId); // Replace with your program's actual ID
		const [cardDataAccount] = await PublicKey.findProgramAddress(seeds, programId);
		
		try {
			let gameDataAccount = await program.account.cardDataAccount.fetch(
				cardDataAccount
			);
			
			let CardId = gameDataAccount.cardId;
			let CardStatus = gameDataAccount.cardStatus;
			let CardLevel = gameDataAccount.cardLevel;
			let Multiplier = gameDataAccount.cardMultiplier;
			let CardResult = gameDataAccount.cardResult;
			CardResult = CardResult.split(",");
			cardResult = CardResult;
			
			if(CardId > cardId){
				if(!firstLoad){
					firstLoad = true;
					setCardStatus(CardStatus);
					multiplier = Multiplier;
					cardId = CardId;
					
					showCard(CardLevel);
					level = CardLevel;
					
					if(CardStatus == 3 && Multiplier > 0){
						hasBought = true;
						setTimeout(() => {
							initScratchEffect(true);
						}, "500");
					}
				}
			}
			
			
		} catch (e) {
			// console.log(`error getting balance: `, e);
		}
	}
	
	
	
	const [now, setNow] = useState(new Date());
	const [timer, setTimer] = useState(30);	
	
	function tick() {
		setNow(new Date());
		if(timer === 30){
			setTimer(1);
			getSolPrice();
			if (wallet.connected && wallet.publicKey) {
				getSolBalance();
				getCardGameData();
			}
		} else {
			setTimer((timer+1));
		}
	}
	
	useEffect(() => {
		var timerID = setInterval(() => tick(), 1000);
		return () => clearInterval(timerID);
	});
	
	useEffect(() => {
		if(!loadOnce){
			initScratchEffectLoad(); //used inside useEffect
			loadOnce = true;
		}
		
	});
	
	
    return(
		<section id="scratch" className="active">
			<div className="main-layout">
				<div className="box referral-box boxxx d-block d-lg-none">
					<div className="referral-title">
					  <span className="referral-icon">💎</span>
					  Earn Commission:
					</div>
					{wallet.connected && (
						<div className="referral-content">
						  <p className="referral-description">Ready to earn commission? Tap the 'Copy Referral Link' button and share your default campaign.</p>
						  <div className="referral-input-group">
							<input type="text" className="referral-input" value={BASE_URL+"?sponsor="+walletAddress} readOnly={true} />
							<button className="referral-copy-btn" onClick={() => window.copyReferralLink()}>Copy Referral Link</button>
						  </div>
						</div>
					  )}

					  {(wallet.connected) || (
						<div className="referral-content">
						  <p className="referral-description">Please, Connect wallet to start Earning by your referral link.</p>
						</div>
					  )}
				</div>
				  
				  
				<div className="box referral-box boxxx d-block d-lg-none">
					<div className="referral-title">
					  <span className="referral-icon">💰</span>
					  Your Commission:
					</div>
					<div className="referral-content">
					  <p className="referral-description">You've earned</p>
					  <div className="referral-input-group">
						<input type="text" className="referral-earnings" value={thousands_separators(refCommission - refCommissionClaimed) + " SOL"} readOnly={true} />
						<button 
							className="referral-claim-btn" 
							onClick={() => claimReferralCommission()}
							disabled={refCommission - refCommissionClaimed <= 0}
						>
							Claim Earnings
						</button>
					  </div>
					</div>
					
					<div className="commission-list">
						<div className="commission-item">Ticket Sold <br /> {thousands_separators(refTicketSold)}</div>
						<div className="commission-item">Total Commission <br /> {thousands_separators(refCommission)} SOL</div>
						<div className="commission-item">Total Earned <br /> {thousands_separators(refCommissionClaimed)} SOL</div>
					</div>
				 </div>
				 
				<div className="box balance-box-mobile d-flex justify-content-between align-items-center d-block d-lg-none boxxx" style={{marginTop: "15px"}}>
					 {wallet.connected && (
						<div>
						
						  {walletAddress.substr(0, 4)}....{walletAddress.substr(walletAddress.length - 4, 4)}
						  <br />
						  💰 Balance : <br />
						  {thousands_separators(solBalance)} SOL {" "}
						  <span style={{color:"green", fontWeight:"bold"}}>(${thousands_separators(solPrice * solBalance,2)})</span>
						  
						</div>
					  )}

					  {(wallet.connected && <WalletDisconnectButton className="web3auth" />) || (
						<>
							<div></div>
							<WalletModalProvider>
								<WalletMultiButton 
									className="btn web3auth" 
								/>
							</WalletModalProvider>
						</>
						
					  )}
				</div>
				
				<div className="left-col">
					<div className="box how-to-play-box boxxx">
						<div className="how-to-play-title">
							<span className="how-to-play-icon">🎮</span>
							How to Play:
						</div>
						
						<ol className="how-to-play-list">
							<li className="how-to-play-item">
								<div className="how-to-play-number">1</div>
								<div className="how-to-play-text">Select a card from the options above (Card 1 – Card 10).</div>
							</li>
							
							<li className="how-to-play-item">
								<div className="how-to-play-number">2</div>
								<div className="how-to-play-text">Click <strong>"Buy Card"</strong> to purchase the selected scratch card.</div>
							</li>
							
							<li className="how-to-play-item">
								<div className="how-to-play-number">3</div>
								<div className="how-to-play-text">Use your mouse or finger to scratch each circle and reveal the numbers.</div>
							</li>
							
							<li className="how-to-play-item">
								<div className="how-to-play-number">4</div>
								<div className="how-to-play-text">Alternatively, click <strong>"Reveal Card"</strong> to uncover all numbers instantly.</div>
							</li>
							
							<li className="how-to-play-item">
								<div className="how-to-play-number">5</div>
								<div className="how-to-play-text">Match <strong>3 identical numbers</strong> to win the corresponding prize.</div>
							</li>
							
							<li className="how-to-play-item">
								<div className="how-to-play-number">6</div>
								<div className="how-to-play-text">Winnings are added to your balance immediately.</div>
							</li>
						</ol>
					</div>

					<div className="box music-box boxxx">
						<div className="music-title">
						<span className="music-icon">🎵</span>
						Music Player:
						</div>
						<div className="music-controls">
							<button className="music-btn" id="prevBtn">⏮️</button>
							<button className="music-btn" id="playPauseBtn">▶️</button>
							<button className="music-btn" id="nextBtn">⏭️</button>
						</div>
						<select className="song-selector" id="songSelector">
							<option value="/sound/m1.mp3">🎶 Casino Royale</option>
							<option value="/sound/m2.mp3">🎸 Lucky Vibes</option>
							<option value="/sound/m3.mp3">🎺 Jackpot Jazz</option>
							<option value="/sound/m4.mp3">🥁 Winner Beat</option>
							<option value="/sound/m5.mp3">🎹 Scratch Symphony</option>
							<option value="/sound/m6.mp3">🎤 Fortune Tune</option>
							<option value="/sound/m7.mp3">🎻 Golden Melody</option>
						</select>
						<div className="current-song" id="currentSong">
						🎵 Now Playing: Casino Royale
						</div>
					</div>
				</div>

				
				
				<div>
					<div className="buttons-wrap">
						{cardsData.map((card, index) => (
							<button 
								key={index}
								className={"btn-purple " + cardActiveClass[index]}
								onClick={() => showCard(index)}
							>
								Card {index + 1}
							</button>
						))}
					</div>

					<div 
						className="box card-box" 
						style={{
							backgroundImage: `url(${cardsData[currentCardIndex].bg})`
							, "--overlay-image" : `url(${cardsData[currentCardIndex].hero})`
						}}
					>
					
						<div className="card-section active">
							<div className="card-header">
								<div className="jackpot-tag imagetemp1">💰 Jackpot: {cardsData[currentCardIndex].bigprize}</div>
								<img src="/all/logo1.png" alt="Tag Logo" className="logo-tag imagetemp1" />
							</div>
							
							<div className="title-section">
								<h1>MEME Edition #{cardsData[currentCardIndex].subtitle}</h1>
								<h3>WIN</h3>
								<p>Jackpot Up To {cardsData[currentCardIndex].bigprize}</p>
								<p>Scratch the same number 3 times to win</p>
							</div>
							
							<div className="scratch-area">
								{cardResult.map((value, index) => (
									<div key={index} className='scratch-box'>
									  <div className='value-text'>${thousands_separators(value)}</div>
									  <canvas className='scratch-canvas' width='75' height='75'></canvas>
									</div>
								))}
							</div>
							
							<div className="action-buttons">
								
								{ hasRevealed ? (
									<button 
										className="btn-reveal"
										onClick={() => claimCard()}
									>
										Claim Reward
									</button>
								) : (
									<button 
										className={!hasBought ? ("") : ("btn-reveal")}
										disabled={!hasBought}
										style={{ cursor: !hasBought && "not-allowed" }}
										onClick={() => revealCard()}
									>
										🔍 Reveal Card
									</button>
								)}
								
								<button 
									className={hasBought ? ("") : ("btn-buy")}
									disabled={hasBought}
									style={{ cursor: hasBought && "not-allowed" }}
									onClick={() => buyCard(currentCardIndex)}
								>
									💳 Buy Card
								</button>
							</div>
							
							<p className="info-text">
								
							</p>
							
							<div className="card-footer">
								<button className="price-tag imagetemp1">${thousands_separators(cardsData[currentCardIndex].price)}</button>
								<div className="footer-info">Each card is packed with massive rewards!</div>
								<img src="/all/logo1.png" alt="Tag Logo" className="footer-logo imagetemp1" />
							</div>
							<div 
								className="win-overlay" 
								style={{
									display:"none"
									,position: "absolute" 
									,top: 0 
									,left: 0 
									,width: "100%" 
									,height: "100%"
									,overflow: ""
									,visible:""
									,zIndex: 10000
									,pointerEvents: "none"
								}}
							></div>
						</div>
					</div>
				</div>
				
				<div className="right-col">
					<div className="box balance-box-desktop d-flex justify-content-between align-items-center d-none d-lg-flex boxxx" style={{marginTop: "15px"}}>
						{wallet.connected && (
							<div>
							
							  {walletAddress.substr(0, 4)}....{walletAddress.substr(walletAddress.length - 4, 4)}
							  <br />
							  💰 Balance : <br />
							  {thousands_separators(solBalance)} SOL {" "}
							  <span style={{color:"green", fontWeight:"bold"}}>(${thousands_separators(solPrice * solBalance,2)})</span>
							  
							</div>
						  )}

						  {(wallet.connected && <WalletDisconnectButton className="web3auth" />) || (
							<>
								<div></div>
								<WalletModalProvider>
									<WalletMultiButton 
										className="btn web3auth" 
									/>
								</WalletModalProvider>
							</>
							
						  )}
					</div>
					
					<div className="box referral-box boxxx d-none d-lg-block">
						<div className="referral-title">
						  <span className="referral-icon">💎</span>
						  Earn Commission:
						</div>
						{wallet.connected && (
							<div className="referral-content">
							  <p className="referral-description">Ready to earn commission? Tap the 'Copy Referral Link' button and share your default campaign.</p>
							  <div className="referral-input-group">
								<input type="text" className="referral-input" value={BASE_URL+"?sponsor="+walletAddress} readOnly={true} />
								<button className="referral-copy-btn" onClick={() => window.copyReferralLink()}>Copy Referral Link</button>
							  </div>
							</div>
						  )}

						  {(wallet.connected) || (
							<div className="referral-content">
							  <p className="referral-description">Please, Connect wallet to start Earning by your referral link.</p>
							</div>
						  )}
					 </div>
					 
					<div className="box referral-box boxxx d-none d-lg-block">
						<div className="referral-title">
						  <span className="referral-icon">💰</span>
						  Your Commission:
						</div>
						<div className="referral-content">
						  <p className="referral-description">You've earned</p>
						  <div className="referral-input-group">
							<input type="text" className="referral-earnings" value={thousands_separators(refCommission - refCommissionClaimed) + " SOL"} readOnly={true} />
							<button 
								className="referral-claim-btn" 
								onClick={() => claimReferralCommission()}
								disabled={refCommission - refCommissionClaimed <= 0}
							>
								Claim Earnings
							</button>
						  </div>
						</div>
						
						<div className="commission-list">
							<div className="commission-item">Ticket Sold <br /> {thousands_separators(refTicketSold)}</div>
							<div className="commission-item">Total Commission <br /> {thousands_separators(refCommission)} SOL</div>
							<div className="commission-item">Total Earned <br /> {thousands_separators(refCommissionClaimed)} SOL</div>
						</div>
					 </div>
					 
					<div className="box prize-table-box boxxx" id="prizeTableBox">
						<div className="prize-table-title">
						  <span className="prize-table-icon">🏆</span>
						  Prize Table:
						</div>
						<div className="prize-rules">
						  <div className="prize-rule">
							<span className="prize-rule-icon">✨</span>
							<span>3x Matching = <span style={{color:"#10b981",fontWeight:"bold"}}>💚 Win</span></span>
						  </div>
						  <div className="prize-rule">
							<span className="prize-rule-icon">⭐</span>
							<span>Match <span style={{color:"#fbbf24", fontWeight:"bold"}}>GOLD</span> = <span style={{color:"#ef4444", fontWeight:"bold"}}>🔥 Big Win</span></span>
						  </div>
						</div>
						<div className="prize-list">
							{cardsData[currentCardIndex].prizes.map((prize, index) => (
								<div key={index} className="prize-item">{prize}</div>
							))}
						</div>
					</div>
					
					

				</div>
			</div>
		</section>
    )
}
export default Board